(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.shopify-section') || document.getElementById('shopify-section-header') || this;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
      this.header.querySelectorAll('mk-mega-navigation').forEach(menu => menu.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);



  

  // Native details remain usable if JavaScript is unavailable.
  if (!customElements.get('mk-mega-navigation')) {
    customElements.define('mk-mega-navigation', class extends HTMLElement {
      connectedCallback() {
        this.cleanup?.abort();
        this.cleanup = new AbortController();
        const signal = this.cleanup.signal;
        this.items = Array.from(this.querySelectorAll('.mk-nav__details'));
        this.desktop = window.matchMedia(`(min-width: ${Number(this.dataset.breakpoint) || 1280}px)`);
        const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.updateHeight = () => {
          this.style.setProperty('--mk-panel-height', `${Math.max(0, window.innerHeight - this.getBoundingClientRect().bottom - 16)}px`);
        };
        this.items.forEach(item => {
          item.addEventListener('toggle', () => {
            if (!item.open) return;
            this.items.forEach(other => { if (other !== item) other.open = false; });
            this.updateHeight();
          }, { signal });
          item.addEventListener('pointerenter', event => {
            if (!hover.matches || !this.desktop.matches || event.pointerType !== 'mouse') return;
            clearTimeout(this.closeTimer);
            clearTimeout(this.openTimer);
            this.openTimer = setTimeout(() => {
              const focused = this.querySelector('.mk-nav__panel :focus');
              if (focused && !item.contains(focused)) return;
              this.close(item);
              item.open = true;
              this.updateHeight();
            }, 100);
          }, { signal });
          item.addEventListener('pointerleave', () => {
            clearTimeout(this.openTimer);
            this.closeTimer = setTimeout(() => {
              if (!item.contains(document.activeElement)) item.open = false;
            }, 180);
          }, { signal });
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            const item = event.target.closest('.mk-nav__details');
            if (item?.open) {
              event.preventDefault();
              this.close();
              item.querySelector('summary').focus();
            }
          }
          if (event.key === 'ArrowDown' && event.target.matches('summary')) {
            event.preventDefault();
            const item = event.target.closest('details');
            this.close(item);
            item.open = true;
            this.updateHeight();
            item.querySelector('.mk-nav__panel a')?.focus();
          }
        }, { signal });
        this.addEventListener('focusout', () => {
          clearTimeout(this.focusTimer);
          this.focusTimer = setTimeout(() => {
            this.items.forEach(item => { if (!item.contains(document.activeElement)) item.open = false; });
          }, 0);
        }, { signal });
        document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.close(); }, { signal });
        window.addEventListener('resize', () => { this.close(); this.updateHeight(); }, { signal });
        window.addEventListener('scroll', this.updateHeight, { signal, passive: true });
        this.updateHeight();
      }
      close(except) {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        this.items?.forEach(item => { if (item !== except) item.open = false; });
      }
      disconnectedCallback() {
        this.close();
        clearTimeout(this.focusTimer);
        this.cleanup?.abort();
      }
    });
  }

  // Relocate the existing search node; retain its theme listeners and predictive search.
  if (!customElements.get('mk-header-layout')) {
    customElements.define('mk-header-layout', class extends HTMLElement {
      connectedCallback() {
        this.breakpoint = window.matchMedia(`(min-width: ${Number(this.dataset.breakpoint) || 1280}px)`);
        this.syncLayout = () => {
          if (this.breakpoint.matches) {
            if (this.source) return;
            const row = this.closest('.header-row');
            const existing = Array.from(row?.querySelectorAll('.desktop-search') || []).find(node => !this.contains(node) && node.querySelector('input[type="search"]'));
            if (existing) {
              this.source = existing;
              this.marker = document.createComment('Original desktop search position');
              existing.before(this.marker);
              this.append(existing);
              const fallback = this.querySelector('.mk-search-form');
              if (fallback) fallback.hidden = true;
            }
          } else this.restore();
        };
        this.breakpoint.addEventListener('change', this.syncLayout);
        this.frame = requestAnimationFrame(this.syncLayout);
      }
      restore() {
        if (this.source && this.marker?.parentNode) this.marker.replaceWith(this.source);
        this.source = null;
        this.marker = null;
        const fallback = this.querySelector('.mk-search-form');
        if (fallback) fallback.hidden = false;
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.breakpoint?.removeEventListener('change', this.syncLayout);
        this.restore();
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
